import { IntlShape } from 'react-intl';
import {
  PASSWORD_MIN_LENGTH,
  PasswordFeedbackMessages,
} from '~/vcl/atoms/01-forms/03-input/02-password-feedback';

export const getPasswordFeedbackMessages = (
  intl: IntlShape,
  minLength: number = PASSWORD_MIN_LENGTH,
): PasswordFeedbackMessages => ({
  valid: intl.formatMessage({
    id: 'password_policy_valid',
    defaultMessage: 'Password is valid.',
  }),
  invalid: intl.formatMessage({
    id: 'password_policy_invalid',
    defaultMessage: 'Password does not meet requirements yet.',
  }),
  weak: intl.formatMessage({
    id: 'password_strength_weak',
    defaultMessage: 'Weak',
  }),
  medium: intl.formatMessage({
    id: 'password_strength_medium',
    defaultMessage: 'Medium',
  }),
  strong: intl.formatMessage({
    id: 'password_strength_strong',
    defaultMessage: 'Strong',
  }),
  minLength: intl.formatMessage(
    {
      id: 'password_policy_criteria_min_length',
      defaultMessage: 'At least {minLength} characters',
    },
    { minLength },
  ),
  letters: intl.formatMessage({
    id: 'password_policy_criteria_letters',
    defaultMessage: 'Contains letters',
  }),
  numbers: intl.formatMessage({
    id: 'password_policy_criteria_numbers',
    defaultMessage: 'Contains numbers',
  }),
});
